const { NODE_ENV } = process.env;

export const getUrl = () => {
  // if (NODE_ENV === "production") {
  return "https://api.passagevan.codapps.com.br";
  // }

  // return "http://localhost:9044";
};
